import {Auth} from 'aws-amplify'
import {CognitoUser} from 'amazon-cognito-identity-js'

export const signOut = (): Promise<void> => Auth.signOut()
export const currentAuthenticatedUser = (): Promise<CognitoUser> => Auth.currentAuthenticatedUser()
